
import {useStore} from './useStore';

export const useOrdersFilterCount = () : number => {
    const filters = useStore( store => store.ui.orders);

    let activeFilterCount = 0;
    if (filters.searchFilter.length > 0) {
        activeFilterCount++;
    }
    if (filters.type !== 'ALL') {
        activeFilterCount++;
    }
    if(filters.dateType !== 'CURRENT_STATUS') {
        activeFilterCount++;
    }
    if(filters.accountingStatus !== 'ALL') {
        activeFilterCount++;
    }

    if(filters.customerFilter) {
        activeFilterCount++;
    }

    return activeFilterCount;
}